// imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import {Container} from "./Container";

// global constants
const horizontalGradient = require("../assets/images/gradient-horizontal.png");
const horizontalGradientReversed = require("../assets/images/gradient-horizontal-reversed.png");
const verticalGradient = require("../assets/images/gradient-vertical.png");
const verticalGradientReversed = require("../assets/images/gradient-vertical-reversed.png");
const verticalGradientThin = require("../assets/images/gradient-vertical-thin.png");
const verticalGradientReversedThin = require("../assets/images/gradient-vertical-thin-reversed.png");

const SCROLL_TYPES = ["horizontal", "vertical", "vertical-thin"];

export class ScrollableContainer extends Component {

    static propTypes = {
        style: PropTypes.any,
        scrollType: PropTypes.oneOf(SCROLL_TYPES)
    };

    static defaultProps = {
        scrollType: SCROLL_TYPES[0]
    };

    constructor(props) {
        // call base constructor
        super(props);

        // instance variables
        this.scrollingContainer = null;

        // initialize state
        this.state = {
            gradientStartOpacity: 0,
            gradientEndOpacity: 1
        }
    }

    componentDidMount() {
        // add scroll listener
        this.scrollingContainer.div.addEventListener('scroll', this.handleScroll);

        // resolve inputs
        const {offsetWidth, scrollWidth, scrollHeight, offsetHeight} = this.scrollingContainer.div;

        // make the bottom gradient invisible if the container is not scrollable
        switch (this.props.scrollType) {
            case SCROLL_TYPES[0]:
                this.setState({
                    gradientEndOpacity: scrollWidth <= offsetWidth ? 0 : 1
                });
                break;
            case SCROLL_TYPES[1]:
            case SCROLL_TYPES[2]:
                this.setState({
                    gradientEndOpacity: scrollHeight <= offsetHeight ? 0 : 1
                });
                break;
        }
    }

    componentWillUnmount() {
        // remove scroll listener
        this.scrollingContainer.div.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = (event) => {
        // resolve inputs
        const {offsetWidth, scrollWidth, scrollLeft, scrollHeight, scrollTop, offsetHeight} = event.srcElement;

        switch (this.props.scrollType) {
            case SCROLL_TYPES[0]:

                this.setState({
                    gradientEndOpacity: this.easingFunction(scrollWidth - offsetWidth - scrollLeft, scrollWidth),
                    gradientStartOpacity: this.easingFunction(scrollLeft, scrollWidth)
                });

                break;
            case SCROLL_TYPES[1]:
            case SCROLL_TYPES[2]:

                this.setState({
                    gradientEndOpacity: this.easingFunction(scrollHeight - offsetHeight - scrollTop, scrollHeight),
                    gradientStartOpacity: this.easingFunction(scrollTop, scrollHeight)
                });

                break;
        }

    };

    /**
     * The easing function is based on the Logistics Growth Model
     * {@link https://people.richland.edu/james/lecture/m116/logs/models.html}
     * The equation for the model is y = a / (1 + b e-kx ), k > 0
     *
     * a = The ceiling of the function
     * b = Curve passes through (0, a/(1+b) )
     *
     * @param scrollPosition The x value for the above equation
     * @param variable The variable used to calculate k (the rate of growth/decay)
     * @returns {number}
     */
    easingFunction = (scrollPosition, variable) => {
        const a = 1; // opacity can only go up to 1
        const b = 100; // we want y = 0 when x = 0
        const k = -0.00032537961 * variable + 0.851; // the 2 constants here were calculated using trial and error

        return a / (1 + b * Math.pow(1.3, -k * scrollPosition));
    };

    render() {

        // resolve inputs
        const {style, children} = this.props;
        const {gradientStartOpacity, gradientEndOpacity} = this.state;

        let gradient, gradientReversed, gradientStyle, gradientStyleReversed;

        // choose gradient image and style based on the scroll type
        switch (this.props.scrollType) {
            case SCROLL_TYPES[0]:
                gradient = horizontalGradient;
                gradientReversed = horizontalGradientReversed;

                const height = this.scrollingContainer ? this.scrollingContainer.div.offsetHeight : 0;
                gradientStyle = {right: 0, top: 0, height: height,  opacity: gradientEndOpacity};
                gradientStyleReversed = {left: 0, top: 0, height: height, opacity: gradientStartOpacity};

                break;
            case SCROLL_TYPES[1]:
                gradient = verticalGradient;
                gradientReversed = verticalGradientReversed;

                gradientStyle = {left: 0, right: 0, bottom: 0, width: "inherit", opacity: gradientEndOpacity};
                gradientStyleReversed = {left: 0, right: 0, top: 0, width: "inherit", opacity: gradientStartOpacity};

                break;
            case SCROLL_TYPES[2]:
                gradient = verticalGradientThin;
                gradientReversed = verticalGradientReversedThin;

                gradientStyle = {left: 0, right: 0, bottom: 0, width: "inherit", opacity: gradientEndOpacity};
                gradientStyleReversed = {left: 0, right: 0, top: 0, width: "inherit", opacity: gradientStartOpacity};

                break;
        }

        return (
            <Container style={styles.container}>

                <Container ref={ref => this.scrollingContainer = ref}
                           style={{...style, overflow: "scroll"}}>
                    {children}
                </Container>

                <img src={gradientReversed}
                     style={{...gradientStyleReversed, ...styles.gradientImage}}/>

                <img src={gradient}
                     style={{...gradientStyle, ...styles.gradientImage}}/>

            </Container>
        )
    }

}

// styles
const styles = {
    container: {
        position: "relative",
    },
    gradientImage: {
        pointerEvents: "none",
        position: "absolute"
    }
};


// WEBPACK FOOTER //
// ./src/components/ScrollableContainer.js